import * as React from 'react';
import getLocal from '@/app/utils/getLocal';
import Header from '@/components/EcoCredits/CommonElement/Header';
import { useProductList } from '@/components/EcoCredits/api';
import { IPageStatus, ProductModule } from '@/components/EcocreditsMonthlyMadness/type';
import EditorLink from 'lowcode/components/EditorLink';
import EditorImg from 'lowcode/components/EditorImg';
import { useGlobal } from '@/utils/useGlobal';
import { useLang } from '@/app/utils/useLang';
import Countdown from './CountDown';
import styled from './index.module.scss';

interface BestOffersProps {
    id?: string;
    title: string;
    desc?: string;
    module: ProductModule;
}

const timeInfo = {
    startTime: new Date('2024/11/28 07:00:00 GMT+8').getTime(),
    endTime: new Date('2024/12/03 16:00:00 GMT+8').getTime(),
};

// const timeInfo = {
//     startTime: new Date('2024/10/28 07:00:00 GMT+8').getTime(),
//     endTime: new Date('2024/12/03 16:00:00 GMT+8').getTime(),
// };

const BestOffers: React.FC<BestOffersProps> = ({ id, title, desc, module }) => {
    const { getSystemTime } = useGlobal();
    const { locale } = getLocal();
    const { t } = useLang('appreciationday');
    const time = getSystemTime();

    const timeStartTime = locale === 'uk' ? new Date('2024/11/28 08:00:00 GMT+8').getTime() : timeInfo.startTime;

    const leftTime = time > timeStartTime ? timeInfo.endTime - time : 0;

    const { productList } = useProductList(module, locale);
    const imgPic =
        locale === 'eu'
            ? {
                  pc: 'https://websiteoss.ecoflow.com/upload/image/1731049326160/bo_eu_pc.jpg',
                  h5: 'https://websiteoss.ecoflow.com/upload/image/1731049330559/bo_eu_m.jpg',
              }
            : {
                  pc: 'https://websiteoss.ecoflow.com/upload/image/1731050087507/bo_uk_pc.jpg',
                  h5: 'https://websiteoss.ecoflow.com/upload/image/1731050090638/bo_uk_m.jpg',
              };

    if (time < timeStartTime || time > timeInfo.endTime) return <></>;

    return (
        <div className={styled.best_offers} id={id}>
            <Header title={title} desc={desc} />
            <Countdown leftTime={leftTime} />
            <div className="products_bestoffer_container">
                {productList.map((item, i) => (
                    <div className="item_card" key={item.productId}>
                        <div className="card_img">
                            <EditorImg className="img" pc={i === 3 ? imgPic.pc : item.imageUrl} h5={i === 3 ? imgPic.h5 : item.imageUrl} />
                        </div>
                        <div className="card_text">
                            <div className="card_text_wrapper">
                                <div className="title">{item.title}</div>
                                <div className="subtitle1">{item.subtitle1}</div>
                                {item.subtitle2 && <div className="subtitle1">{item.subtitle2}</div>}
                            </div>
                            <div className="context_price">
                                <div className="price_1">{item.memberPrice2}</div>
                                {item.compareAtPrice2 !== item.memberPrice2 && <div className="price_2">{item.compareAtPrice2}</div>}
                            </div>
                            <div className="button_action">
                                <EditorLink href={item.productUrl} target="_blank">
                                    <button className="button_learn_more">{t('learn_more')}</button>
                                </EditorLink>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BestOffers;
